import { render, staticRenderFns } from "./AddCategoryForm.vue?vue&type=template&id=205c7231&"
import script from "./AddCategoryForm.vue?vue&type=script&lang=js&"
export * from "./AddCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports